import './counter-signer.scss'

import { defineComponent, PropType } from 'vue';
import { faTrash } from '@fortawesome/free-solid-svg-icons';

import { getTranslatedString, CounterSignerResource, createTranslatedString } from '@skinsoft/types';

import { reactiveVueMixin } from "@skinsoft/reactive-vue";
import { FIELD_VALUE_UPDATED } from '@skinsoft/ui2/events';
import { COUNTER_SIGNER_UPDATED, REMOVE_COUNTER_SIGNER } from '../../../../../../busTopics';
import { TextField } from '@skinsoft/ui2/form/text-field';
import { THESAURUS_TERM_SELECTED } from '@skinsoft/ui/src/thesaurus-term-tree/thesaurus-term-tree-modal';
import ThesaurusTermTree from '@skinsoft/ui/src/thesaurus-term-tree';

export const CounterSigner = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sTextField: TextField,
        sThesaurusTermTree: ThesaurusTermTree,
    },
    props: {
        counterSigner: {
            type: Object as PropType<CounterSignerResource>,
            required: true,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        canBeDeleted: {
            type: Boolean,
        },
    },
    template: require('./counter-signer.html'),
    data() {
        return {
            minusIcon: faTrash,
            FIELD_VALUE_UPDATED,
            THESAURUS_TERM_SELECTED,
        }
    },
    methods: {
        onTranslatedStringUpdated(path: string, value: string): CounterSignerResource {
            let updatedSigner: CounterSignerResource = {...this.counterSigner}
            if(updatedSigner[path]?.translatedString) {
                updatedSigner[path].translatedString[this.getAppLocale()] = value
            } else {
                updatedSigner[path] = createTranslatedString(this.getAppLocale(), value)
            }
            return updatedSigner
        },

        getSignerName() {
            return getTranslatedString(this.counterSigner.surnameFirstName, this.getAppLocale())
        },

        onNameUpdated(name: string) {
            let updatedSigner: CounterSignerResource = this.onTranslatedStringUpdated('surnameFirstName', name)
            this.updateSigner(updatedSigner)
        },

        getSignerFunction() {
            return this.counterSigner.function
        },

        onFunctionUpdated(signerFunction: string) {
            let updatedSigner: CounterSignerResource = {...this.counterSigner}
            updatedSigner.function = signerFunction
            this.updateSigner(updatedSigner)
        },

        updateSigner(updatedSigner: CounterSignerResource) {
            this.$emit(
                COUNTER_SIGNER_UPDATED,
                updatedSigner
            )
        },

        deleteSigner() {
            this.$emit(
                REMOVE_COUNTER_SIGNER,
                this.counterSigner.index
            )
        },
    },
})
